import { createContext, useContext } from 'react';

export interface ToastOptions {
  /** Label for an inline action button (e.g. "Undo"). Omitting it keeps the
   * toast a pure announcement — the pre-library behaviour, unchanged. */
  actionLabel?: string;
  /** Runs when the action button is activated; also dismisses the toast. */
  onAction?: () => void;
  /** How long the toast stays visible. Defaults to the standard 4 s. The
   * undo-delete toast passes the undo window so the affordance lives exactly
   * as long as undo is possible. */
  durationMs?: number;
}

export interface ToastContextValue {
  announce: (message: string, options?: ToastOptions) => void;
  /**
   * Create docks the visual toast into this node (under the step map) so it
   * cannot cover the map. Other routes leave it null and keep the fixed
   * top-center toast. The live region is unchanged either way.
   */
  setVisualHost: (el: HTMLElement | null) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext);
  if (!context) throw new Error('useToast must be used inside ToastProvider');
  return context;
}
